<template>

    <small v-show="msg" class="c-form_error">{{ msg }}</small>

</template>

<script>

export default {

    name: 'FormErrorMsg',

    props: {
        msg: String
    }

}

</script>

<style lang="scss">

@import '~Style/_utils.scss';

.c-form_error {
    display: block;
    color: $c-red;
    font-size: 1rem;
    padding-top: 3px;
    opacity: 0;
    transform: translateY(-20%);
    max-height: 0;
    animation: fade-in .3s ease-in-out;
    animation-fill-mode: forwards;

    @keyframes fade-in {
        100% {
            opacity: 1;
            transform: translateY(0%);
            max-height: 110px;
        }
    }
}

</style>

